// NAVIGATION --------------------------------------------------------------------------------

const navigationPressQuotes = document.querySelector('.press_quotes_custom .navigation');
const navigationDotsPressQuotes = document.querySelector('.press_quotes_custom .navigation .dots');
const containerItemsPressQuotes = document.querySelector('.press_quotes_custom .quotes_items');
const itemsPressQuotes = document.querySelectorAll('.press_quotes_custom .quotes_items .item');

const automaticItemsPressQuotesPadding = containerItemsPressQuotes.offsetWidth - itemsPressQuotes[1].offsetWidth - 80;

//containerItemsPressQuotes.style.paddingLeft = `${automaticItemsPressQuotesPadding}px`;

let dotId = 0;

for(let i=0;i<itemsPressQuotes.length;i++){

    const dot = document.createElement("div");
    dot.setAttribute("class", "dot");
    dot.setAttribute("id", `${dotId}`);

    navigationDotsPressQuotes.appendChild(dot);

    dotId++;

}

const dotsNavigationPressQuotes = document.querySelectorAll('.press_quotes_custom .navigation .dot');

let blockQuotesWidth;

if(window.innerWidth > 749 ){
    blockQuotesWidth = itemsPressQuotes[0].offsetWidth+80;
}else{
    blockQuotesWidth = itemsPressQuotes[0].offsetWidth+40;
}

let dotIdSave = 1;

dotsNavigationPressQuotes[0].classList.add('active');

function updateTransformPressQuotes(dotId, amount){

    // RESET DOTS
    for(let i=0; i<dotsNavigationPressQuotes.length;i++){
        dotsNavigationPressQuotes[i].classList.remove('active');
    }

    // SET CURRENT DOT
    dotsNavigationPressQuotes[dotId].classList.add('active');

    // SET TRANSFORM
    containerItemsPressQuotes.style.transform = `translate3d(-${amount}px, 0px, 0px)`;

    // RESET INTERVAL
    //resetIntevalPressQuotes();
}

if(window.innerWidth > 749 ){
    updateTransformPressQuotes(dotIdSave, dotIdSave * blockQuotesWidth);
}else{
    //updateTransformPressQuotes(dotIdSave, dotIdSave * blockQuotesWidth + 15 * dotIdSave);
    updateTransformPressQuotes(dotIdSave, dotIdSave * blockQuotesWidth);
}

dotsNavigationPressQuotes.forEach(dot => {
    dot.addEventListener('click', () => {
        updateTransformPressQuotes(parseInt(dot.id), parseInt(dot.id) * blockQuotesWidth)
        dotIdSave = parseInt(dot.id);
    })
})

// AUTOMATIC TRANSITION

function checkDotActivePressQuotes(){
    if(dotIdSave == dotsNavigationPressQuotes.length-1){
        dotIdSave = 0;
    }else{
        dotIdSave = dotIdSave+1;
    }
    updateTransformPressQuotes(dotIdSave, dotIdSave * blockQuotesWidth);
}

//intevalPressQuotes = setInterval(checkDotActivePressQuotes, 7000);

function resetIntevalPressQuotes() {
    clearInterval(intevalPressQuotes);
    intevalPressQuotes = setInterval(checkDotActivePressQuotes, 7000);
}

// MANUAL TRANSITION

const buttonsNavigationPressQuotes = document.querySelectorAll('.press_quotes_custom .navigation .btn');

buttonsNavigationPressQuotes.forEach(btn => {
    btn.addEventListener('click', () => {

        if(btn.id=='left'){;

            if(dotIdSave == 0){
                dotIdSave = dotsNavigationPressQuotes.length-1;
            }
            else if(dotIdSave < dotsNavigationPressQuotes.length){
                dotIdSave === dotIdSave--;
            }else{
                dotIdSave = 0;
            }

            if(window.innerWidth > 749 ){
                updateTransformPressQuotes(dotIdSave, dotIdSave * blockQuotesWidth);
            }else{
                //updateTransformPressQuotes(dotIdSave, dotIdSave * blockQuotesWidth + 15 * dotIdSave);
                updateTransformPressQuotes(dotIdSave, dotIdSave * blockQuotesWidth);
            }

        }

        else if(btn.id=='right'){

            if(dotIdSave < dotsNavigationPressQuotes.length-1){
                dotIdSave = dotIdSave+1;
            }else{
                dotIdSave = 0;
            }

            if(window.innerWidth > 749 ){
                updateTransformPressQuotes(dotIdSave, dotIdSave * blockQuotesWidth);
            }else{
                updateTransformPressQuotes(dotIdSave, dotIdSave * blockQuotesWidth);
            }

        }

    })
})